/* BELGRAVE ORCHIDS CUSTOM — Selby customer chat widget (Freedom backend).
   Loaded by snippets/bo-head.liquid. Our own file: survives Crave theme updates.
   - "Chat with us" pill, bottom-right (raised on phones to clear Safari's toolbar)
   - One-time nudge on product/collection pages after 20s (once per visit)
   - Any link to #chat, or element with [data-open-chat], opens the chat
   - window.openSelbyChat() opens it from anywhere
   - Sends the signed logged-in customer (window.SELBY_CUSTOMER, set in bo-head.liquid) and page path with each message */
(function () {
  if (window.__selbyLoaded) return;
  window.__selbyLoaded = true;

  var BACKEND = 'https://freedom-backend-production-2d0b.up.railway.app';
  var NUDGE_DELAY_MS = 20000;
  var TEAL = '#365f5f';

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function getSessionId() {
    var id = store('selby_session');
    if (!id) { id = 'web-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9); store('selby_session', id); }
    return id;
  }

  function renderText(t) {
    var d = document.createElement('div');
    var escaped = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var withLinks = escaped.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" style="color:' + TEAL + ';text-decoration:underline">$1</a>');
    var withBold = withLinks.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    d.innerHTML = withBold.replace(/\n/g, '<br>');
    return d;
  }

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';

  var css = ''
    /* Launcher pill */
    + '#selby-btn{position:fixed;right:16px;bottom:calc(84px + env(safe-area-inset-bottom,0px));z-index:9999;display:flex;align-items:center;gap:8px;height:48px;padding:0 18px 0 15px;border-radius:999px;background:' + TEAL + ';color:#fff;border:2px solid #fff;cursor:pointer;font:600 15px/1 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;letter-spacing:.01em;box-shadow:0 6px 20px rgba(0,0,0,.22);transition:transform .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent}'
    + '#selby-btn:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(0,0,0,.26)}'
    + '#selby-btn:focus-visible{outline:3px solid #f2efdd;outline-offset:2px}'
    + '#selby-btn svg{width:20px;height:20px;flex-shrink:0}'
    + '#selby-btn.hidden{display:none}'
    + '@media(min-width:750px){#selby-btn{right:24px;bottom:24px}}'
    /* Nudge bubble */
    + '#selby-nudge{position:fixed;right:16px;bottom:calc(142px + env(safe-area-inset-bottom,0px));z-index:9999;max-width:260px;background:#fff;color:#1a2e2e;border-radius:12px;padding:12px 34px 12px 14px;font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-shadow:0 8px 28px rgba(0,0,0,.18);cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity .25s,transform .25s;display:none}'
    + '#selby-nudge.show{display:block}#selby-nudge.in{opacity:1;transform:none}'
    + '#selby-nudge:after{content:"";position:absolute;right:28px;bottom:-7px;width:14px;height:14px;background:#fff;transform:rotate(45deg);box-shadow:3px 3px 6px rgba(0,0,0,.06)}'
    + '#selby-nudge strong{color:' + TEAL + '}'
    + '#selby-nudge-x{position:absolute;top:4px;right:4px;width:28px;height:28px;border:none;background:none;color:#888;font-size:18px;line-height:1;cursor:pointer}'
    + '@media(min-width:750px){#selby-nudge{right:24px;bottom:84px}}'
    /* Panel */
    + '#selby-panel{position:fixed;z-index:10000;background:#fff;display:none;flex-direction:column;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;bottom:0;left:0;right:0;width:100%;height:85vh;max-height:85vh;border-radius:16px 16px 0 0;box-shadow:0 -4px 32px rgba(0,0,0,.18)}'
    + '@media(min-width:750px){#selby-panel{bottom:24px;left:auto;right:24px;width:370px;height:540px;max-height:calc(100vh - 48px);border-radius:14px;box-shadow:0 8px 40px rgba(0,0,0,.18)}}'
    + '#selby-panel.open{display:flex}'
    + '#selby-header{background:' + TEAL + ';color:#fff;padding:14px 16px;display:flex;align-items:center;gap:10px;flex-shrink:0}'
    + '.selby-av{width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700}'
    + '.selby-nm{font-size:15px;font-weight:600}.selby-sb{font-size:12px;opacity:.85}'
    + '#selby-close{margin-left:auto;background:none;border:none;color:rgba(255,255,255,.85);cursor:pointer;padding:8px;font-size:24px;line-height:1;min-width:40px;min-height:40px;display:flex;align-items:center;justify-content:center}'
    + '#selby-messages{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:14px 12px;display:flex;flex-direction:column;gap:10px}'
    + '.smsg{max-width:84%;padding:9px 12px;border-radius:10px;font-size:14px;line-height:1.5;word-break:break-word}'
    + '.smsg.bot{background:#f2efdd;color:#1a2e2e;align-self:flex-start;border-bottom-left-radius:3px}'
    + '.smsg.user{background:' + TEAL + ';color:#fff;align-self:flex-end;border-bottom-right-radius:3px}'
    + '.smsg.typing{opacity:.6;font-style:italic}'
    + '#selby-form{display:flex;gap:8px;padding:10px 12px calc(10px + env(safe-area-inset-bottom,0px));border-top:1px solid #e5e7eb;flex-shrink:0;background:#fff}'
    + '#selby-input{flex:1;border:1px solid #d1d5db;border-radius:8px;padding:10px 12px;font-size:16px;outline:none;font-family:inherit;resize:none;line-height:1.4;max-height:80px;-webkit-appearance:none}'
    + '#selby-input:focus{border-color:' + TEAL + '}'
    + '#selby-send{background:' + TEAL + ';color:#fff;border:none;border-radius:8px;padding:10px 16px;cursor:pointer;font-size:14px;font-weight:600;flex-shrink:0;min-width:60px}'
    + '#selby-send:disabled{opacity:.5;cursor:not-allowed}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // Launcher
  var btn = document.createElement('button');
  btn.id = 'selby-btn';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Chat with us');
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'selby-panel');
  btn.innerHTML = ICON + '<span>Chat with us</span>';

  // Nudge
  var nudge = document.createElement('div');
  nudge.id = 'selby-nudge';
  nudge.setAttribute('role', 'status');
  var onProduct = /\/products\//.test(location.pathname);
  nudge.innerHTML = (onProduct
      ? 'Questions about growing this one? <strong>Chat with us.</strong>'
      : 'Not sure which one suits your conditions? <strong>Chat with us.</strong>')
    + '<button id="selby-nudge-x" type="button" aria-label="Dismiss">&times;</button>';

  // Panel
  var panel = document.createElement('div');
  panel.id = 'selby-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Chat with Belgrave Orchids');
  panel.innerHTML = '<div id="selby-header"><div class="selby-av">S</div><div><div class="selby-nm">Selby</div><div class="selby-sb">Belgrave Orchids assistant</div></div><button id="selby-close" type="button" aria-label="Close chat">&times;</button></div>'
    + '<div id="selby-messages" aria-live="polite"></div>'
    + '<form id="selby-form"><textarea id="selby-input" placeholder="Type your question..." rows="1" aria-label="Your message"></textarea><button type="submit" id="selby-send">Send</button></form>';

  document.body.appendChild(nudge);
  document.body.appendChild(btn);
  document.body.appendChild(panel);

  var msgs = panel.querySelector('#selby-messages'),
      inp = panel.querySelector('#selby-input'),
      snd = panel.querySelector('#selby-send'),
      frm = panel.querySelector('#selby-form'),
      cls = panel.querySelector('#selby-close'),
      isOpen = false, busy = false, nudgeTimer = null;

  function addMsg(role, text) {
    var d = document.createElement('div');
    d.className = 'smsg ' + role;
    if (role === 'bot') d.appendChild(renderText(text)); else d.textContent = text;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function addTyping() {
    var d = document.createElement('div');
    d.className = 'smsg bot typing';
    d.textContent = 'Selby is typing...';
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function greet() {
    if (msgs.children.length === 0) addMsg('bot', "Hi, I'm Selby, the Belgrave Orchids assistant. I can help with orchid care, order status, shipping, or finding the right plant. What can I help with?\n\nChats are saved so our team can follow up. See our [privacy policy](https://belgraveorchids.com.au/policies/privacy-policy).");
  }
  function setBusy(v) { busy = v; snd.disabled = v; inp.disabled = v; }

  function hideNudge() {
    if (nudgeTimer) { clearTimeout(nudgeTimer); nudgeTimer = null; }
    nudge.classList.remove('in');
    setTimeout(function () { nudge.classList.remove('show'); }, 250);
  }

  function openChat() {
    if (isOpen) return;
    isOpen = true;
    store('selby_nudged', '1');
    hideNudge();
    panel.classList.add('open');
    btn.classList.add('hidden');
    btn.setAttribute('aria-expanded', 'true');
    greet();
    setTimeout(function () { inp.focus(); }, 100);
  }
  function closeChat() {
    isOpen = false;
    panel.classList.remove('open');
    btn.classList.remove('hidden');
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }
  window.openSelbyChat = openChat;

  function send(t) {
    if (!t.trim() || busy) return;
    addMsg('user', t);
    setBusy(true);
    var ty = addTyping();
    fetch(BACKEND + '/api/chat/message', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: t, session_id: getSessionId(), customer: window.SELBY_CUSTOMER || null, page: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { ty.remove(); addMsg('bot', d.reply || d.error || 'Sorry, something went wrong.'); })
      .catch(function () { ty.remove(); addMsg('bot', 'Sorry, I could not connect. Please try again, or email hello@belgraveorchids.com.au.'); })
      .then(function () { setBusy(false); inp.focus(); });
  }

  btn.addEventListener('click', openChat);
  cls.addEventListener('click', closeChat);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeChat(); });

  frm.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = inp.value.trim();
    if (!t) return;
    inp.value = '';
    inp.style.height = '';
    send(t);
  });
  inp.addEventListener('input', function () { inp.style.height = ''; inp.style.height = Math.min(inp.scrollHeight, 80) + 'px'; });
  inp.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); frm.dispatchEvent(new Event('submit', { cancelable: true })); } });

  // Open from any link to #chat or element with data-open-chat (e.g. Contact / Help page buttons)
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[href="#chat"], a[href$="#chat"], [data-open-chat]');
    if (!el) return;
    e.preventDefault();
    openChat();
  });
  if (location.hash === '#chat') openChat();

  // Nudge: product & collection pages only, once per visit
  nudge.addEventListener('click', function (e) {
    if (e.target.id === 'selby-nudge-x') { store('selby_nudged', '1'); hideNudge(); return; }
    openChat();
  });
  if (/\/(products|collections)\//.test(location.pathname) && !store('selby_nudged')) {
    nudgeTimer = setTimeout(function () {
      if (isOpen || store('selby_nudged')) return;
      store('selby_nudged', '1');
      nudge.classList.add('show');
      requestAnimationFrame(function () { nudge.classList.add('in'); });
    }, NUDGE_DELAY_MS);
  }
})();